import React from 'react';
import { Award, Users, Shield, Zap } from 'lucide-react';
import { whyChooseUsData } from '../data/mock';

const iconMap = {
  Award: Award,
  Users: Users,
  Shield: Shield,
  Zap: Zap
};

const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-us-section" className="py-20 sm:py-24 md:py-32 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary mb-4 block">Why Us</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4 tracking-tight">
              Why Choose M DION
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground font-light max-w-xl mx-auto">
              We combine expertise, premium products, and dedication to deliver exceptional lighting solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-10">
            {whyChooseUsData.map((item) => {
              const IconComponent = iconMap[item.icon] || Award;
              return (
                <div key={item.title} data-testid={`why-choose-${whyChooseUsData.indexOf(item)}`} className="group">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-500">
                    <IconComponent className="text-primary" size={22} />
                  </div>
                  <h3 className="font-semibold text-foreground mb-2 tracking-tight">{item.title}</h3>
                  <p className="text-sm text-muted-foreground font-light leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
